import config from '../config';

export async function fetchSchematicMetering(backendFetch, siteId, showPhases = false) {
    const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/schematic/metering/" + siteId, {
        method: "POST", headers: {"Content-Type": "application/json"}, body: JSON.stringify({
            data: {"phased": showPhases}
        })
    })
    return await f.json()
}

export async function schematicClearImportConstraint(backendFetch, siteId, node_id, device_id) {
    const f = await backendFetch(config.REACT_APP_HOST + '/api/v2/schematic/constraints/clear-import/' + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({data: {node_id: node_id,
                                            device_id: device_id
                                        }})
    })
    const r = await f.json()
    if (r.error) {
        console.error(r.error)
    }
    return JSON.parse(r)
}

export async function schematicClearExportConstraint(backendFetch, siteId, node_id, device_id) {
    const f = await backendFetch(config.REACT_APP_HOST + '/api/v2/schematic/constraints/clear-export/' + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({data: {node_id: node_id,
                                    device_id: device_id
                                    }})
    })
    const r = await f.json()
    if (r.error) {
        console.error(r.error)
    }
    return JSON.parse(r)
}

export async function schematicSetConstraints(backendFetch, siteId, node_id, importc, exportc, importPrevValue, exportPrevValue, device_id) {
    const f = await backendFetch(config.REACT_APP_HOST + '/api/v2/schematic/constraints/set/' + siteId,
        {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({
                data: {node_id: node_id,
                    import_constraint: importc,
                    import_constraint_prev: importPrevValue,
                    export_constraint: exportc,
                    export_constraint_prev: exportPrevValue,
                    device_id: device_id
                }
            })
        })
    const r = await f.json()
    if (r.error) {
        console.error(r.error)
    }
    return JSON.parse(r)
}

export async function schematicUnlinkDevice(backendFetch, siteId, node_id, oldDeviceId) {
    const f = await backendFetch(config.REACT_APP_HOST + '/api/v2/schematic/unlink-device/' + siteId,
        {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({data: {node_id: node_id, device_id: oldDeviceId}})
        })
    const r = await f.json()
    return JSON.parse(r)
}

export async function schematicLinkDevice(backendFetch, siteId, node_id, device_id) {
    const f = await backendFetch(config.REACT_APP_HOST + '/api/v2/schematic/link-device/' + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({data: {node_id: node_id, device_id: device_id}})
    })
    const r = await f.json()
    if (r.error) {
        console.error(r.error)
    }
    return JSON.parse(r)
}

export async function schematicRemoveNode(backendFetch, siteId, node_id, device_id) {
    const f = await backendFetch(config.REACT_APP_HOST + '/api/v2/schematic/remove-node/' + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({data: {node_id: node_id, device_id: device_id}})
    })
    const r = await f.json()
    if (r.error) {
        console.error(r.error)
    }
    return JSON.parse(r)
}

export async function schematicAddNode(backendFetch, siteId, parent_node_id, device_id) {
    const f = await backendFetch(config.REACT_APP_HOST + '/api/v2/schematic/add-node/' + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({ data: {parent_node_id: parent_node_id, device_id: device_id}})
    })
    const r = await f.json()

    if (r.error) {
        console.error(r.error)
    }
    return JSON.parse(r)
}

export async function schematicUpload(backendFetch, siteId) {
    const f = await backendFetch(config.REACT_APP_HOST + '/api/v2/schematic/upload/' + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
    })
    const r = await f.json()
    if (r.error) {
        console.error(r.error)
    }
    return r
}